//封装本地存取token
const key = 'token-key'

//存
const setToken = (token) => {
    window.localStorage.setItem('tokentime', Date.now() + 1000 * 60 * 300)
    return window.localStorage.setItem(key, token)
}

//取
const getToken = () => {
    let expired = window.localStorage.getItem('tokentime') || Date.now + 1;
    const now = Date.now();
    if (now >= expired) {
        window.localStorage.removeItem('tokentime');
        window.localStorage.removeItem(key);
        return false;
    }
    return window.localStorage.getItem(key)
}
//删除
const removeToken = () => {
    return window.localStorage.removeItem(key)
}

export {
    setToken,
    getToken,
    removeToken
}